
import { Component } from 'vue-property-decorator';

// API
import { getAllCities } from '@/utils/api/Cities';

// Components
import VAdministrationMain from '@/components/Administration/VAdministrationMain.vue';
import VAdministrationHeader from '@/components/Administration/VAdministrationHeader.vue';
import VPageTitle from '@/components/Administration/VPageTitle.vue';

import VAdministrationActionbar from '@/components/Administration/VAdministrationActionbar.vue';
import VAdministrationPrimaryTable from '@/components/Administration/VAdministrationPrimaryTable.vue';

// Mixins
import VAdministrationPrimaryTableMixin from '@/mixins/VAdministrationPrimaryTableMixin';

// Enums
import AdministrationPageNamesEnum from '@/ship/Enums/AdministrationPageNamesEnum';

// Interfaces
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import City from '@/ship/Models/City';

@Component({
    components: {
        VAdministrationMain,
        VAdministrationHeader,
        VPageTitle,

        VAdministrationActionbar,
        VAdministrationPrimaryTable,
    },
})
export default class CitiesPage extends VAdministrationPrimaryTableMixin {
    readonly currentPageName = AdministrationPageNamesEnum.Cities;
    readonly request = getAllCities;

    declare items: City[];

    public getRequestParams(): GetRequestParams {
        return {
            filter: 'id;name',
            search: `id,name:${this.search}`,
        };
    }
}
